
import {
  NeighbourhoodSelectWithTerritoriesClass,
  InputSelector,
} from "components/dropdown_menu/neighbourhood_select/with_territory"

const DEFAULT_SELECTOR = {
  scope:    "form",
}


const Factory = {
  create(selector?: InputSelector){
    return new NeighbourhoodSelectWithTerritoriesClass(Object.assign({}, DEFAULT_SELECTOR, selector))
  },
}

export {
  Factory,
  NeighbourhoodSelectWithTerritoriesClass,
}
